import { Box } from '@mui/material';
import { Separator } from 'react-resizable-panels';

/**
 * Custom styled resize handle for react-resizable-panels v4.
 *
 * v4 Separator forces flexGrow:0, flexShrink:0 AFTER user styles but spreads
 * user styles AFTER flexBasis:auto — so we override flexBasis directly.
 */
export const ResizeHandle = () => {
  return (
    <Separator
      style={{
        flexBasis: '4px',
        background: 'transparent',
      }}
    >
      <Box
        sx={{
          width: '4px',
          height: '100%',
          mx: 'auto',
          backgroundColor: 'divider',
          cursor: 'col-resize',
          position: 'relative',
          transition: 'background-color 0.2s ease',
          '&:hover': {
            backgroundColor: 'primary.main',
          },
          '[data-separator="active"] &': {
            backgroundColor: 'primary.main',
          },
          '&::after': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: '3px',
            height: '40px',
            borderRadius: '2px',
            backgroundColor: 'action.active',
            opacity: 0,
            transition: 'opacity 0.2s ease',
          },
          '&:hover::after, [data-separator="active"] &::after': {
            opacity: 0.6,
          },
        }}
      />
    </Separator>
  );
};
